module.exports = __webpack_public_path__ + "img/electric_icon_borne-de-recharge.75e35e58.svg";